const menuItems = [
  {
    id:1,
    title: "Home",
    url: "/",
    cName: "nav-links",
  },
  {
    id:2,
    title: "About Us",
    url: "/AboutUs",
    cName: "nav-links",
  },
  {
    id:3,
    title: "Products",
    url: "/Products",
    cName: "nav-links",
  },
  {
    id:4,
    title: "Contact Us",
    url: "/Contact",
    cName: "nav-links",
  },
];

export default menuItems;
